var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['booking-status-bar', ("booking-status-bar--" + _vm.statusBarPriority)]},[(_vm.statusBarMessage.length)?_c('div',[_c(_vm.statusBarComponent,{tag:"component"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }